<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__factorystore}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="外销合同编号：">
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="请输入外销合同编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="合同编号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="storageName"
          label="仓库名称"
          header-align="center"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="品番号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="品名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="size"
          label="规格"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="attr1"
          label="幅宽"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="attr2"
          label="克重"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="当前数量"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/factorystore/page",
        getDataListIsPage: true,
        exportURL: "/trade/factorystore/export",
        deleteURL: "/trade/factorystore",
        deleteIsBatch: true,
      },
      dataForm: {
        agreementCode: "",
      },
    };
  },
  components: {},
};
</script>
